/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Price_LabelInputs */

const en_admin_resource_form_price_label = /** @type {(inputs: Admin_Resource_Form_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const de_admin_resource_form_price_label = /** @type {(inputs: Admin_Resource_Form_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis`)
};

const es_admin_resource_form_price_label = /** @type {(inputs: Admin_Resource_Form_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio`)
};

const fr_admin_resource_form_price_label = /** @type {(inputs: Admin_Resource_Form_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix`)
};

const nl_admin_resource_form_price_label = /** @type {(inputs: Admin_Resource_Form_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijs`)
};

/** @type {(inputs: Admin_Resource_Form_Price_LabelInputs) => LocalizedString} */
const it_admin_resource_form_price_label = en_admin_resource_form_price_label;

/** @type {(inputs: Admin_Resource_Form_Price_LabelInputs) => LocalizedString} */
const pt_br2_admin_resource_form_price_label = en_admin_resource_form_price_label;

/** @type {(inputs: Admin_Resource_Form_Price_LabelInputs) => LocalizedString} */
const pl_admin_resource_form_price_label = en_admin_resource_form_price_label;

/** @type {(inputs: Admin_Resource_Form_Price_LabelInputs) => LocalizedString} */
const hu_admin_resource_form_price_label = en_admin_resource_form_price_label;

/** @type {(inputs: Admin_Resource_Form_Price_LabelInputs) => LocalizedString} */
const ro_admin_resource_form_price_label = en_admin_resource_form_price_label;

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Admin_Resource_Form_Price_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_price_label = /** @type {((inputs?: Admin_Resource_Form_Price_LabelInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Price_LabelInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_price_label(inputs)
	if (locale === "de") return de_admin_resource_form_price_label(inputs)
	if (locale === "es") return es_admin_resource_form_price_label(inputs)
	if (locale === "fr") return fr_admin_resource_form_price_label(inputs)
	if (locale === "nl") return nl_admin_resource_form_price_label(inputs)
	if (locale === "it") return it_admin_resource_form_price_label(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_price_label(inputs)
	if (locale === "pl") return pl_admin_resource_form_price_label(inputs)
	if (locale === "hu") return hu_admin_resource_form_price_label(inputs)
	return ro_admin_resource_form_price_label(inputs)
});
export { admin_resource_form_price_label as "admin.resource_form.price_label" }